module.exports = __webpack_public_path__ + "img/icons.d9076090.svg";